export const Marquee = ({ items, className = "" }) => (
    <div
        data-testid="editorial-marquee"
        className={`border-y border-slate-200 bg-steel-light/50 py-5 ${className}`}
    >
        <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-10 gap-y-3 px-5 sm:px-8">
            {items.map((item, i) => (
                <span
                    key={i}
                    className="flex items-center gap-10 whitespace-nowrap font-display text-[13px] font-bold uppercase tracking-[0.22em] text-navy/60"
                >
                    {item}
                    {i < items.length - 1 && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber" aria-hidden="true" />}
                </span>
            ))}
        </div>
    </div>
);
